import { render, staticRenderFns } from "./StatPanel.vue?vue&type=template&id=72629bbe"
import script from "./StatPanel.vue?vue&type=script&lang=js"
export * from "./StatPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports